import { render, staticRenderFns } from "./OAuthItem.vue?vue&type=template&id=ae08e8f6&scoped=true"
import script from "./OAuthItem.vue?vue&type=script&lang=js"
export * from "./OAuthItem.vue?vue&type=script&lang=js"
import style0 from "./OAuthItem.vue?vue&type=style&index=0&id=ae08e8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae08e8f6",
  null
  
)

export default component.exports